import { Column, Row } from "../../../../widget";
import { AccessInvitesForm, AddressForm, BannerForm, DetailsForm, LogoForm } from "../../../shared";
import { useOrganisation } from "./useOrganisation";

const Organisation = (): JSX.Element => {
  const {
    dataIsLoading,
    organisationDefaultDetails,
    organisationDefaultAddress,
    organisationDefaultBanner,
    organisationDefaultLogo,
    countries,
    dispatch,
    objectUuid,
    objectType,
    objectKey,
    currentUserType,
    updateDetails,
    onDetailsUpdated,
  } = useOrganisation();

  return (
    <>
      <div className="TemplateTabCard">
        {!dataIsLoading && (
          <>
            <Row spacingV="m">
              <Column span={12}>
                <h2>Organisation details</h2>
              </Column>
            </Row>
            <Row spacingV="ll">
              <Column span={12}>
                <span className="body1">These details will be used for your public listing in the directory.</span>
              </Column>
            </Row>
            {organisationDefaultDetails && (
              <DetailsForm
                objectUuid={objectUuid}
                objectKey={objectKey}
                updateDetails={updateDetails}
                organisationDefaultDetails={organisationDefaultDetails}
                onDetailsUpdated={onDetailsUpdated}
                dispatch={dispatch}
              />
            )}
          </>
        )}
      </div>
      <div className="TemplateTabCard Rounded">
        <Row spacingV="ll">
          <Column span={5}>
            <h2>Address</h2>
          </Column>
        </Row>
        {organisationDefaultAddress && (
          <AddressForm
            countries={countries}
            organisationDefaultAddress={organisationDefaultAddress}
            currentUserType={currentUserType}
            dispatch={dispatch}
          />
        )}
      </div>
      {organisationDefaultDetails?.accessInviteOptOut !== undefined && (
        <div className="TemplateTabCard Rounded">
          <AccessInvitesForm
            objectUuid={objectUuid}
            objectKey={objectKey}
            updateDetails={updateDetails}
            organisationDefaultDetails={organisationDefaultDetails}
            onDetailsUpdated={onDetailsUpdated}
          />
        </div>
      )}
      <div className="TemplateTabCard Rounded">
        <Row spacingV="m">
          <Column span={5}>
            <h2>Logo</h2>
          </Column>
        </Row>
        <Row spacingV="ll">
          <Column span={12}>
            <span className="body1">This logo will be displayed in the navigation bar.</span>
          </Column>
        </Row>
        <LogoForm
          objectUuid={objectUuid}
          objectType={objectType}
          organisationDefaultLogo={organisationDefaultLogo}
          dispatch={dispatch}
        />
      </div>
      <div className="TemplateTabCard Rounded">
        <Row spacingV="m">
          <Column span={5}>
            <h2>Banner</h2>
          </Column>
        </Row>
        <Row spacingV="ll">
          <Column span={12}>
            <span className="body1">This banner will feature on the dashboard</span>
          </Column>
        </Row>
        <BannerForm
          objectUuid={objectUuid}
          objectType={objectType}
          organisationDefaultBanner={organisationDefaultBanner}
          dispatch={dispatch}
        />
      </div>
    </>
  );
};

export default Organisation;
